import { AuthorizedRoute } from "./AuthorizedRoute";
import { NonAuthorizedRoute } from "./NonAuthorizedRoute";
import { Route, Switch, useHistory } from "react-router-dom";
import { MainLayout } from "components/layout/main";
import { AppRoute } from "enums/appRoute";

import Login from "components/auth/login";
import Signup from "components/auth/signup";
import VerifyAccount from "components/auth/verifyAccount";
import UrlDesigner from "components/url-desinger";
import Portfolio from "components/portfolio";
import Dashboard from "components/dashboard";
import MyCards from "components/my-cards";
import UserProfile from "components/user-profile";
import Analytics from "components/analytics";
import Settings from "components/settings";
import { useEffect } from "react";

export default function Routes() {
  return (
    <Switch>
      <NonAuthorizedRoute exact path={AppRoute.LOGIN} component={Login} />
      <NonAuthorizedRoute exact path={AppRoute.SIGNUP} component={Signup} />
      <NonAuthorizedRoute
        exact
        path={AppRoute.VERIFYACCOUNT}
        component={VerifyAccount}
      />
      <Route exact path={AppRoute.PORTFOLIO} component={Portfolio} />
      <AuthorizedRoute
        exact
        path={AppRoute.PORTFOLIO_PREVIEW}
        component={Portfolio}
      />
      <AuthorizedRoute
        exact
        path={AppRoute.URLDESIGNER}
        render={() => <UrlDesigner builderType="PRO" />}
      />
      <AuthorizedRoute
        exact
        path={AppRoute.URLTEMPLATEDESIGNER}
        render={() => <UrlDesigner builderType="ENTERPRISE_TEMPLATE" />}
      />
      <AuthorizedRoute
        exact
        path={AppRoute.HOME}
        render={() => (
          <MainLayout>
            <Dashboard />
          </MainLayout>
        )}
      />
      <AuthorizedRoute
        exact
        path={AppRoute.MYCARDS}
        render={() => (
          <MainLayout>
            <MyCards />
          </MainLayout>
        )}
      />
      <AuthorizedRoute
        exact
        path={AppRoute.MYPROFILE}
        render={() => (
          <MainLayout>
            <UserProfile />
          </MainLayout>
        )}
      />
      <AuthorizedRoute
        exact
        path={AppRoute.ANALYTICS}
        render={() => (
          <MainLayout>
            <Analytics />
          </MainLayout>
        )}
      />
      <AuthorizedRoute
        exact
        path={AppRoute.SETTINGS}
        render={() => (
          <MainLayout>
            <Settings />
          </MainLayout>
        )}
      />
    </Switch>
  );
}
